module.exports = __webpack_public_path__ + "js/img/instagram_icon.ce41af6a.svg";